<div class="about" [class.modal]="modal">
  <div class="block">
    <app-icon width="30" height="30" file="status" icon="status-verified"></app-icon>
    <span class="about__title">{{ 'about-verification-widget.title' | translate }}</span>
  </div>
  <div class="about__description">
    <span class="main-desc">{{ 'about-verification-widget.description' | translate }}</span>
  </div>

  <div class="block">
    <app-icon width="30" height="30" file="status" icon="status-verified"></app-icon>
    <span class="about__title">{{ 'about-verification-widget.verified-profile.title' | translate }}</span>
  </div>

  <div class="about__description">
    <ul class="about__list">
      <li *ngFor="let info of infoArray">{{'about-verification-widget.verified-profile.description-' + info | translate}}</li>
    </ul>
  </div>

  <div class="block">
    <app-icon width="30" height="30" file="status" icon="status-not-verified"></app-icon>
    <span class="about__title">{{ 'about-verification-widget.unverified-profile.title' | translate }}</span>
  </div>

  <div class="about__description">
    <ul class="about__list">
      <li>{{'about-verification-widget.unverified-profile.description' | translate}}</li>
    </ul>
  </div>
</div>
